webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FORMS_UPDATE = 'FORMS_UPDATE';
var defaultState = function () { return ({
    signin: {
        login: '',
        password: ''
    },
    signup: {
        name: '',
        login: '',
        password: ''
    }
}); };
/**
 * Creates action for updating field value
 */
exports.update = function (form, name, value) { return ({
    type: FORMS_UPDATE,
    form: form,
    name: name,
    value: value
}); };
exports.default = function (state, action) {
    if (state === void 0) { state = defaultState(); }
    switch (action.type) {
        case FORMS_UPDATE:
            // @todo: waiting for immutable state
            state[action.form][action.name] = action.value;
            return state;
        default:
            return state;
    }
};


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
Object.defineProperty(exports, "__esModule", { value: true });
var BASE_PATH = global.basePath || '/';
exports.PATH_ENTRY = BASE_PATH;
exports.PATH_SIGNIN = BASE_PATH + "signin";
exports.PATH_SIGNUP = BASE_PATH + "signup";

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(120);
/**
 * Primitive logo with react icon
 */
var Logo = /** @class */ (function (_super) {
    __extends(Logo, _super);
    function Logo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Logo.prototype.render = function () {
        return React.createElement("span", { className: styles.logo });
    };
    return Logo;
}(React.Component));
exports.Logo = Logo;
exports.default = Logo;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(45));
var Input_1 = __webpack_require__(45);
exports.default = Input_1.default;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(127);
/**
 * Just stateless input
 */
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Input.prototype.render = function () {
        var _a = this.props, inputProps = _a.inputProps, onChange = _a.onChange;
        return (React.createElement("label", { className: styles.label },
            React.createElement("input", __assign({}, inputProps, { className: styles.input, onChange: onChange }))));
    };
    return Input;
}(React.Component));
exports.Input = Input;
exports.default = Input;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(47));
var Button_1 = __webpack_require__(47);
exports.default = Button_1.default;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cx = __webpack_require__(128);
var Button_styl_1 = __webpack_require__(129);
var ButtonPreset;
(function (ButtonPreset) {
    ButtonPreset[ButtonPreset["Default"] = Button_styl_1.presetDefault] = "Default";
    ButtonPreset[ButtonPreset["Accent"] = Button_styl_1.presetAccent] = "Accent";
})(ButtonPreset = exports.ButtonPreset || (exports.ButtonPreset = {}));
/**
 * Plain button
 */
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var _a = this.props, preset = _a.preset, children = _a.children;
        return React.createElement("button", { className: cx(Button_styl_1.button, preset) }, children);
    };
    return Button;
}(React.Component));
exports.Button = Button;
exports.default = Button;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(49);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(50);
var store_1 = __webpack_require__(51);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(30);
var react_redux_1 = __webpack_require__(5);
var react_router_dom_1 = __webpack_require__(6);
var PageEntry_1 = __webpack_require__(117);
var rootElement = document.querySelector('.app');
ReactDOM.render(React.createElement(react_redux_1.Provider, { store: store_1.default },
    React.createElement(react_router_dom_1.HashRouter, null,
        React.createElement(PageEntry_1.default, null))), rootElement);


/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_thunk_1 = __webpack_require__(23);
var reducers_1 = __webpack_require__(52);
var redux_1 = __webpack_require__(4);
var composeWithDevTools = __webpack_require__(70).composeWithDevTools;
exports.createStore = function () {
    return redux_1.createStore(reducers_1.default, composeWithDevTools(redux_1.applyMiddleware(redux_thunk_1.default)));
};
exports.default = exports.createStore();


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(4);
var metaDuck_1 = __webpack_require__(68);
var formsDuck_1 = __webpack_require__(13);
exports.default = redux_1.combineReducers({
    meta: metaDuck_1.default,
    forms: formsDuck_1.default
});


/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var pkg = __webpack_require__(69);
exports.default = function () { return (__assign({}, pkg)); };


/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = {"name":"reaction","version":"0.0.4","description":"React/Redux/ReactRouter starter kit","main":"index.js","engines":{"node":">=6.0.0","npm":">=3.0.0"},"scripts":{"start":"node scripts/start.js","lint:es":"eslint src/ scripts/ --ext .js --ext .jsx","lint:ts":"tslint 'src/**/*.{ts,tsx}' -e 'src/**/*.d.ts' -- --project=tsconfig.json","lint":"yarn run lint:es && yarn run lint:ts","build":"NODE_ENV=production webpack --config=webpack.config.prod.js","build-info":"NODE_ENV=production webpack --colors --display-modules --config=webpack.config.prod.js","test":"jest","test:watch":"jest --watch","test:coverage":"jest --coverage","styleguide":"styleguidist server","styleguide:build":"styleguidist build","precommit":"lint-staged","prepush":"yarn run lint && yarn test","clean":"rm -rf build/ coverage/ demo/","demo":"bash scripts/demo.sh","release":"standard-version && git push --follow-tags origin $(git rev-parse --abbrev-ref HEAD)","commit":"git-cz","format":"prettier --write '{src,scripts}/**/*.{ts,tsx,js,jsx,json}'"},"jest":{"modulePaths":["./src"],"moduleFileExtensions":["ts","tsx","js","jsx"],"transform":{"\\.(ts|tsx)$":"<rootDir>/node_modules/ts-jest/preprocessor.js"},"testRegex":"/__tests__/.*\\.(ts|tsx|js|jsx)$"},"repository":{"type":"git","url":"git+https://github.com/albburtsev/reaction.git"},"keywords":["React","Flux","App"],"author":"Alexander Burtsev","license":"MIT","bugs":{"url":"https://github.com/albburtsev/reaction/issues"},"homepage":"https://github.com/albburtsev/reaction#readme","dependencies":{"@types/classnames":"^2.2.0","@types/react":"^16.0.7","@types/react-dom":"^15.5.5","@types/react-redux":"^5.0.9","@types/react-router-dom":"^4.0.8","babel-jest":"^19.0.0","classnames":"^2.2.5","leaflet":"1.0.0-beta.1","lint-staged":"^4.2.3","prettier":"^1.7.2","prop-types":"^15.6.0","react":"^16.0.0","react-dom":"^16.0.0","react-redux":"^5.0.6","react-router-dom":"^4.2.2","redux":"^3.7.2","redux-thunk":"^2.2.0","tslint-config-prettier":"^1.5.0"},"devDependencies":{"@types/jest":"^19.2.4","@types/node":"^8.0.25","babel-core":"^6.3.21","babel-eslint":"^7.0.0","babel-loader":"^6.2.0","babel-plugin-react-transform":"^2.0.0-beta1","babel-plugin-syntax-class-properties":"^6.3.13","babel-plugin-transform-class-properties":"^6.3.13","babel-plugin-transform-object-rest-spread":"^6.6.4","babel-preset-env":"^1.6.0","babel-preset-react":"^6.3.13","chalk":"^1.1.0","commitizen":"^2.9.6","connect-history-api-fallback":"^1.3.0","css-loader":"^0.28.4","cz-conventional-changelog":"^2.0.0","eslint":"^3.6.1","eslint-loader":"^1.8.0","eslint-plugin-babel":"^3.0.0","eslint-plugin-react":"^6.3.0","extract-text-webpack-plugin":"^2.1.2","file-loader":"^0.11.2","http-proxy-middleware":"^0.17.3","husky":"^0.13.4","jest":"^19.0.2","json-loader":"^0.5.4","lodash":"^4.16.2","react-dev-utils":"^0.4.1","react-docgen-typescript":"^0.0.11","react-styleguidist":"^5.4.4","redux-devtools-extension":"^2.13.0","source-map-loader":"^0.1.5","standard-version":"^4.2.0","style-loader":"^0.18.2","stylus":"^0.54.5","stylus-loader":"^3.0.1","ts-jest":"^20.0.5","ts-loader":"^2.3.4","tslint":"^5.4.3","typescript":"^2.5.3","typings-for-css-modules-loader":"^1.5.0","webpack":"^3.0.0","webpack-dev-server":"^2.5.0","webpack-merge":"^4.1.0"},"config":{"commitizen":{"path":"node_modules/cz-conventional-changelog"}}}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(4).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
   false ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
   false ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var styles = __webpack_require__(118);
var React = __webpack_require__(0);
var paths = __webpack_require__(22);
var Logo_1 = __webpack_require__(119);
var react_router_dom_1 = __webpack_require__(6);
var FooterContainer_1 = __webpack_require__(121);
var FormSignupContainer_1 = __webpack_require__(124);
var FormSigninContainer_1 = __webpack_require__(130);
/**
 * Entry page
 */
var PageEntry = function () { return (React.createElement("div", { className: styles.page },
    React.createElement("div", { className: styles.content },
        React.createElement(react_router_dom_1.Link, { className: styles.logo, to: paths.PATH_ENTRY },
            React.createElement(Logo_1.default, null)),
        React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_dom_1.Route, { path: paths.PATH_SIGNIN, component: FormSigninContainer_1.default }),
            React.createElement(react_router_dom_1.Route, { path: paths.PATH_SIGNUP, component: FormSignupContainer_1.default }),
            React.createElement(react_router_dom_1.Route, { component: FormSigninContainer_1.default }))),
    React.createElement(FooterContainer_1.default, null))); };
exports.default = PageEntry;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page":"_3AzBP_V1WP26Ph0tK-asf5","content":"sk-exuK4U44Gt6baGqjb7","logo":"_1p9RS529rI7KmEQ1H2psXp"};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(43));
var Logo_1 = __webpack_require__(43);
exports.default = Logo_1.default;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo":"_1whYKORePsyDnQ8WcHSyuc"};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(5);
var Footer_1 = __webpack_require__(122);
var mapStateToProps = function (_a) {
    var _b = _a.meta, description = _b.description, version = _b.version;
    return ({
        description: description,
        version: version
    });
};
var FooterContainer = react_redux_1.connect(mapStateToProps)(Footer_1.default);
exports.default = FooterContainer;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(123);
/**
 * Footer with useless information
 */
var Footer = function (_a) {
    var description = _a.description, version = _a.version;
    return (React.createElement("footer", { className: styles.footer },
        React.createElement("a", { className: styles.githubLink, href: "https://github.com/albburtsev/reaction" }),
        description,
        ", v",
        version));
};
exports.default = Footer;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"w0zeZJui-dWxOYi7J8Yuf","github-link":"_3JJ4Mc7WGc2xD19PlIb28q","githubLink":"_3JJ4Mc7WGc2xD19PlIb28q"};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(5);
var FormSignup_1 = __webpack_require__(125);
var formsActions = __webpack_require__(13);
var mapStateToProps = function (_a) {
    var signup = _a.forms.signup;
    return ({
        form: signup
    });
};
var mapDispatchToProps = function (dispatch) { return ({
    onChange: function (_a) {
        var target = _a.target;
        var _b = target, name = _b.name, value = _b.value;
        dispatch(formsActions.update('signup', name, value));
    }
}); };
var FormSignupContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps, null, { pure: false } // @todo: waiting for immutable store
)(FormSignup_1.default);
exports.default = FormSignupContainer;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var styles = __webpack_require__(126);
var React = __webpack_require__(0);
var paths_1 = __webpack_require__(22);
var react_router_dom_1 = __webpack_require__(6);
var Input_1 = __webpack_require__(44);
var Button_1 = __webpack_require__(46);
var FormSignup = function (_a) {
    var _b = _a.form, name = _b.name, login = _b.login, password = _b.password, onChange = _a.onChange;
    return (React.createElement("form", null,
        React.createElement("p", { className: styles.hint },
            React.createElement(react_router_dom_1.Link, { to: paths_1.PATH_SIGNIN }, "Already have an account? Sign in")),
        React.createElement(Input_1.default, { inputProps: {
                required: true,
                autoFocus: true,
                name: 'name',
                value: name,
                placeholder: 'Name, e.g. John Smith'
            }, onChange: onChange }),
        React.createElement(Input_1.default, { inputProps: {
                required: true,
                type: 'email',
                name: 'login',
                value: login,
                placeholder: 'Email'
            }, onChange: onChange }),
        React.createElement(Input_1.default, { inputProps: {
                required: true,
                type: 'password',
                name: 'password',
                value: password,
                placeholder: 'Password'
            }, onChange: onChange }),
        React.createElement("div", { className: styles.button },
            React.createElement("span", { title: "Licensing Agreements", className: styles.license }),
            React.createElement(Button_1.default, { preset: Button_1.ButtonPreset.Accent }, "Sign up"))));
};
exports.default = FormSignup;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hint":"_3pRctpb6VRn-DbC61jMzTP","button":"dHxmKjmN2ptoJqmxQs0NZ","license":"_2dQMGJf0reiMo5FpPEea72"};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"_1XeOx8En3EOnW6VKOiTJ_w","input":"_3VNk0gTOE52SPTt0iH6mvt"};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"exY2XxzKqaQGzKwXMiaos","preset_default":"_60FyaZbmWjMM01AFQBnMR","presetDefault":"_60FyaZbmWjMM01AFQBnMR","preset_accent":"MuuZkCxS-4Z2klRsp-PK","presetAccent":"MuuZkCxS-4Z2klRsp-PK"};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(5);
var FormSignin_1 = __webpack_require__(131);
var formsActions = __webpack_require__(13);
var mapStateToProps = function (_a) {
    var signin = _a.forms.signin;
    return ({
        form: signin
    });
};
var mapDispatchToProps = function (dispatch) { return ({
    onChange: function (_a) {
        var target = _a.target;
        var _b = target, name = _b.name, value = _b.value;
        dispatch(formsActions.update('signin', name, value));
    }
}); };
var FormSigninContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps, null, { pure: false } // @todo: waiting for immutable store
)(FormSignin_1.default);
exports.default = FormSigninContainer;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var paths_1 = __webpack_require__(22);
var react_router_dom_1 = __webpack_require__(6);
var Input_1 = __webpack_require__(44);
var Button_1 = __webpack_require__(46);
var styles = __webpack_require__(132);
var FormSignin = function (_a) {
    var _b = _a.form, login = _b.login, password = _b.password, onChange = _a.onChange;
    return (React.createElement("form", null,
        React.createElement("p", { className: styles.hint },
            React.createElement(react_router_dom_1.Link, { to: paths_1.PATH_SIGNUP }, "Don't have an account? Sign up")),
        React.createElement(Input_1.default, { inputProps: {
                required: true,
                autoFocus: true,
                type: 'email',
                name: 'login',
                value: login,
                placeholder: 'Email'
            }, onChange: onChange }),
        React.createElement(Input_1.default, { inputProps: {
                required: true,
                type: 'password',
                name: 'password',
                value: password,
                placeholder: 'Password'
            }, onChange: onChange }),
        React.createElement("p", { className: styles.button },
            React.createElement(Button_1.default, { preset: Button_1.ButtonPreset.Accent }, "Sign in"))));
};
exports.default = FormSignin;


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hint":"_1shXrsd6vNZVZQCfyV3i9P","button":"_1pOW2rDYvkgM3b9Qp3kVaT"};

/***/ })
],[48]);


// WEBPACK FOOTER //
// app.bundle.js